import React, { useContext, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../css/navbar.css';
import { AuthContext } from '../contexts/AuthContext';

// Lista delle voci di menu con il permesso richiesto
export const links = [
  { to: '/dashboard',         label: 'Dashboard',             iconClass: 'fas fa-tachometer-alt',   permission: 'live_view'             },
  { to: '/add-program',       label: 'Aggiungi Programma',    iconClass: 'fas fa-clipboard-list',   permission: 'programs_create'       },
  { to: '/add-person',        label: 'Aggiungi Persone',      iconClass: 'fas fa-user-plus',        permission: 'people_create'         },
  { to: '/add-company',       label: 'Aggiungi Azienda',      iconClass: 'fas fa-building',         permission: 'people_create'         },
  { to: '/add-qualification', label: 'Aggiungi Qualifica',    iconClass: 'fas fa-award',            permission: 'qualifications_create' },
  { to: '/add-schedule',      label: 'Aggiungi Programmazione', iconClass: 'fas fa-calendar-alt',   permission: 'schedulings_create'    },
  { to: '/add-topic',         label: 'Aggiungi Argomento',    iconClass: 'fas fa-tags',             permission: 'topics_create'         },
  { to: '/add-rubrica',       label: 'Aggiungi Rubrica',      iconClass: 'fas fa-address-book',     permission: 'rubrica_create'        },
  { to: '/prerolls',          label: 'Prerolls',              iconClass: 'fas fa-film',             permission: 'prerolls_view'         },
  { to: '/prerolls-ext',      label: 'Prerolls EXT',          iconClass: 'fas fa-cloud-upload-alt', permission: 'prerolls_view'         },
  // { to: '/skin',              label: 'Skin',                  iconClass: 'fas fa-th-large',         permission: 'live_view' },
  { to: '/tickets',           label: 'Ticket',                iconClass: 'fas fa-ticket-alt',       permission: 'tickets_view'             },
  { to: '/turnazione',        label: 'Turnazione',            iconClass: 'fas fa-calendar-check',   permission: 'shifts_view'              },
  { to: '/instagram',         label: 'Instagram DM',          iconClass: 'fab fa-instagram',        permission: 'instagram_manage'         },
  { to: '/live-chat',         label: 'Live Chat',             iconClass: 'fab fa-youtube',          permission: 'live_chat_manage'         },
  { to: '/playlist',          label: 'Playlist',              iconClass: 'fas fa-list-ol',          permission: 'playlist_manage'          },
  { to: '/media-converter',   label: 'Media Converter',       iconClass: 'fas fa-arrows-rotate',    permission: 'media_converter_manage'   },
  { to: '/survey-analytics',  label: 'Radio Radio 2026',      iconClass: 'fas fa-chart-pie',        permission: 'survey_analytics_view'    },
  { to: '/activities',        label: 'Activities',            iconClass: 'fas fa-clock-rotate-left', permission: 'activities_view'          },
];

const Navbar = ({ sidebarOpen, closeSidebar, onlyHamburger }) => {
  const { pathname } = useLocation();
  const { hasPermission } = useContext(AuthContext);

  // helper: vero se ho il permesso globale o solo "own"
  const can = perm => hasPermission(perm) || hasPermission(`${perm}_own`);

  // filtro i link basandomi su can(permission)
  const visibleLinks = links.filter(link => can(link.permission));

  // scroll to top on ogni cambio di route
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <>
      {/* Navbar desktop */}
      {!onlyHamburger && (
        <nav className="navbar desktop-navbar">
          <div className="navbar-container">
            <ul className="navbar-menu">
              {visibleLinks.map(({ to, label, iconClass }) => (
                <li key={to}>
                  <NavLink
                    to={to}
                    className={({ isActive }) => (isActive ? 'active' : undefined)}
                  >
                    <i className={`${iconClass} nav-icon`} aria-hidden="true" />
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      )}

      {/* Overlay per chiudere sidebar cliccando fuori */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar} />
      )}

      {/* Sidebar mobile */}
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <ul className="sidebar-menu">
          {visibleLinks.map(({ to, label, iconClass }) => (
            <li key={to} onClick={closeSidebar}>
              <NavLink
                to={to}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                <i className={`${iconClass} nav-icon`} aria-hidden="true" />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Navbar;
